import ListItemAdjustments from "../../../../components/@documents/item_adjustments/ListItemAdjustments";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemAdjustmentsPage() {

    return (
        <ListItemAdjustments 
            routeType={routeTypes.admin}
        />
    )
}